var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-logo-container",
      class: { collapse: _vm.collapse },
    },
    [
      _c(
        "transition",
        { attrs: { name: "sidebarLogoFade" } },
        [
          _vm.collapse
            ? _c(
                "router-link",
                {
                  key: "collapse",
                  staticClass: "sidebar-logo-link sidebar-logo-link--collapse",
                  attrs: { to: "/" },
                },
                [
                  _vm.smallLogo
                    ? _c("img", {
                        staticClass: "sidebar-logo sidebar-logo--mark",
                        attrs: { src: _vm.smallLogo, alt: "安骏" },
                      })
                    : _vm._e(),
                ]
              )
            : _c(
                "router-link",
                {
                  key: "expand",
                  staticClass: "sidebar-logo-link sidebar-logo-link--expand",
                  attrs: { to: "/" },
                },
                [
                  _vm.largeLogo
                    ? _c("img", {
                        staticClass: "sidebar-logo sidebar-logo--brand",
                        attrs: { src: _vm.largeLogo, alt: "安骏快递" },
                      })
                    : _vm._e(),
                ]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }